/* Happy Monkfruit — shared cart state.
   Every block on the page used to fetch /cart.js for itself (product script,
   sticky bar, cart drawer, header badge) — four or five round trips for one
   answer. This hands out a single in-flight promise and caches the result
   until something actually changes the cart.

   Idempotent and dependency-free: safe to load more than once and in any
   order relative to the blocks that use it. */
(function () {
  var HMF = window.HMF = window.HMF || {};
  if (HMF.cart) return;

  var CART_URL = (HMF.cartUrl || '/cart') + '.js';
  var cache = null;      /* last known cart object */
  var inflight = null;   /* promise of a request currently on the wire */

  function read(force) {
    if (!force && cache) return Promise.resolve(cache);
    if (inflight) return inflight;
    inflight = fetch(CART_URL, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        inflight = null;
        if (c) cache = c;
        return c || cache;
      })
      .catch(function () {
        inflight = null;
        return cache;
      });
    return inflight;
  }

  /* Cart JSON, from cache when we have it. Pass true after a mutation. */
  HMF.cart = read;

  /* Drop the cache without fetching — the next read goes to the network. */
  HMF.invalidateCart = function () { cache = null; };

  /* Some callers (add to cart, quantity change) already receive the fresh
     cart in their own response. Handing it over here saves another request. */
  HMF.setCart = function (c) { if (c && typeof c.item_count === 'number') cache = c; return c; };

  /* Synchronous peek — null until the first read resolves. */
  HMF.cartCache = function () { return cache; };
})();
